import { useCurrentUser } from '@hooks/useCurrentUser'
import NavigationLoggedIn from '@components/header/NavigationLoggedIn'
import NavigationLoggedOut from '@components/header/NavigationLoggedOut'

function Header() {
    const { data: currentUser } = useCurrentUser()

    return <header>{currentUser ? <NavigationLoggedIn currentUser={currentUser} /> : <NavigationLoggedOut />}</header>
}

export default Header
